/* DateCard.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./DateCard.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import Image from '@atlaskit/image';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { onAIAnswerTabClick } from '../../../ai-answer-dialog/analytics';
import { useAnalytics } from '../../../common/controller/analytics';
import { getSAINLayerFrontendMutiArmExperiment } from '../../../common/utils/get-sain-layer-frontend-experiment';
import { AIAnswerTab, aiAnswerTabsOrder } from '../../../constants';
import { AIDisclaimerAndFeedback } from '../../common/ui/ai-disclaimer-and-feedback';
import { AITabs } from '../../common/ui/ai-tabs';
import { AITabsHeader, AITabsHeaderWithSourcesStack } from '../../common/ui/ai-tabs-header';
import { AITabsPanel } from '../../common/ui/ai-tabs-panel';
import { AITabsSources } from '../../common/ui/ai-tabs-sources';
import CalendarDark from '../assets/calendar-dark.svg';
import CalendarLight from '../assets/calendar-light.svg';
import { StandardActionsKnowledgeCard } from '../standard-cards/StandardActionsKnowledgeCard';
var messages = defineMessages({
  knowledge_card_date_category: {
    id: 'search_ai_knowledge_card_date_category',
    defaultMessage: 'Date',
    description: 'Category header for date knowledge card'
  }
});
var styles = {
  fullHeight: "_4t3i1osq",
  containerStyles: "_ca0qze3t _u5f3ze3t _19bvze3t _n3tdze3t",
  disclaimer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66"
};
export var DateCard = function DateCard(_ref) {
  var date = _ref.date;
  var _useState = useState(AIAnswerTab.AI_ANSWER),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var sources = commonAttributes.sources;
  var _getSAINLayerFrontend = getSAINLayerFrontendMutiArmExperiment({
      abTestId: 'kd_sain_sources_redesign_pt_2'
    }),
    cohortSourcesRedesignExperimentPt2 = _getSAINLayerFrontend.cohort;
  var handleTabChange = useCallback(function (selectedTabIndex) {
    var selectedTab = aiAnswerTabsOrder[selectedTabIndex];
    setSelectedTab(selectedTab);
    fireAnalyticsEvent(onAIAnswerTabClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      selectedTab: selectedTab
    })));
  }, [setSelectedTab, fireAnalyticsEvent, commonAttributes]);
  return /*#__PURE__*/React.createElement(Stack, {
    alignBlock: "stretch",
    grow: "fill",
    spread: "space-between",
    xcss: styles.fullHeight
  }, /*#__PURE__*/React.createElement(AITabs, {
    onChange: handleTabChange,
    selectedTabIndex: aiAnswerTabsOrder.indexOf(selectedTab)
  }, cohortSourcesRedesignExperimentPt2 === 'sources_tab_redesign' ? /*#__PURE__*/React.createElement(AITabsHeaderWithSourcesStack, {
    sources: sources
  }) : /*#__PURE__*/React.createElement(AITabsHeader, {
    showSourcesTab: sources.length > 0
  }), /*#__PURE__*/React.createElement(AITabsPanel, null, /*#__PURE__*/React.createElement(StandardActionsKnowledgeCard, {
    name: "smart-answer-date-knowledge-card",
    category: formatMessage(messages.knowledge_card_date_category),
    primaryDescription: date,
    media: /*#__PURE__*/React.createElement(Image, {
      src: CalendarLight,
      srcDark: CalendarDark,
      alt: ""
    }),
    size: "full",
    containerStyles: styles.containerStyles
  })), sources.length > 0 ? /*#__PURE__*/React.createElement(AITabsPanel, null, /*#__PURE__*/React.createElement(AITabsSources, null)) : null), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.disclaimer
  }, /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
    showFeedbackButtons: true,
    showCopyButton: true,
    copyText: date
  })));
};